'use strict';

var objectPath = require('object-path');

exports.compactObject = require('./compactObject');
exports.deepClone = require('./deepClone');
exports.deepExtend = require('./deepExtend');
exports.deepGet = objectPath.get;
exports.deepSet = require('./deepSet');
exports.getObjectsDiff = require('./getObjectsDiff');
exports.deepCompact = require('./deepCompact');
